var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxImaging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bd88586a-0af9-424f-9138-be39072a5878",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "b199f1b3-e11c-4274-af86-94887fe1a925",
    "data-name": "Path 91",
    d: "M15.342,3.758H4.658A1.566,1.566,0,0,0,3.1,5.321V14.68a1.566,1.566,0,0,0,1.563,1.562H15.342a1.566,1.566,0,0,0,1.563-1.562V5.321a1.566,1.566,0,0,0-1.563-1.563m.173,10.922a.174.174,0,0,1-.173.173H4.658a.174.174,0,0,1-.173-.173h0V5.321a.173.173,0,0,1,.173-.173H15.342a.172.172,0,0,1,.173.172h0Z",
    style: {
      fill: "#005a7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "aee972db-63fd-4e4f-8af9-075ef028d8bb",
    "data-name": "Path 92",
    d: "M12.935,9.232a.588.588,0,1,0,0-1.176H10.588v-.47h1.778a.588.588,0,1,0,0-1.176H10.588V6.094a.588.588,0,0,0-1.176,0V6.41H7.633a.588.588,0,0,0,0,1.176H9.411v.47H7.061a.588.588,0,1,0,0,1.176H9.408V9.7H7.289a.588.588,0,1,0,0,1.176H9.412v.834C9,11.683,8.621,11.63,8.3,11.585c-.766-.107-1.228-.171-1.565.123a.738.738,0,0,0-.253.563c0,.856,1.647,2.271,3.523,2.271s3.523-1.416,3.523-2.271a.734.734,0,0,0-.253-.563c-.338-.294-.8-.229-1.564-.122-.326.045-.708.1-1.117.127v-.834H12.71a.588.588,0,1,0,0-1.176H10.588v-.47ZM11.8,12.763a2.972,2.972,0,0,1-3.6,0,10.792,10.792,0,0,0,3.6,0",
    style: {
      fill: "#005a7d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxImaging);
export default __webpack_public_path__ + "static/media/bxImaging.24d76b6677a457f37c2f104bd7cb3282.svg";
export { ForwardRef as ReactComponent };